import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
  href: string;
  children: React.ReactNode;
}

const ExternalLink: React.FC<Props> = ({ children, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-teal-600 font-medium"
    children={children}
  />
);

export default observer(ExternalLink);
